



























import { Component, Prop, Vue } from 'vue-property-decorator';
import WidgetInfrastructureModals from '@/components/widgets/WidgetInfrastructureModals.vue';
import WidgetRecruitmentPool from '@/components/widgets/WidgetRecrutimentPool.vue';
import WidgetImmovableModals from '@/components/widgets/widgetImmovableModals.vue';
import WidgetQualityOfLifeModals from '@/components/widgets/WidgetQualityOfLifeModals.vue';
import WidgetEnvironnementModals from '@/components/widgets/WidgetEnvironnementModals.vue';
import { MapStore } from '@/store/map';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: {
    WidgetInfrastructureModals,
    WidgetRecruitmentPool,
    WidgetImmovableModals,
    WidgetQualityOfLifeModals,
    WidgetEnvironnementModals
  }
})
export default class RightSideModals extends Vue {
  @Prop({ required: true }) readonly isMobileDevice: boolean;

  private _mapStore!: MapStore;
  projectDefaultIcon = `${process.env.VUE_APP_PROJECT}.svg`;
  created() {
    this._mapStore = getModule(MapStore, this.$store);
  }
}
